import { render, staticRenderFns } from "./Wap_WDD008_Produce.vue?vue&type=template&id=61d40908&scoped=true&"
import script from "./Wap_WDD008_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_WDD008_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_WDD008_Produce.vue?vue&type=style&index=0&id=61d40908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d40908",
  null
  
)

export default component.exports